import { useSearchParams } from "react-router-dom"
import HeatmapView from "@/routes/apt/[apt_code]/report/_components/heatmap/heatmap-view"
import { useEffect } from "react"
import { reportStore } from "@/routes/apt/[apt_code]/report/report-store"
import { langStore } from "@/stores/lang-store"
import { toast } from "sonner"
import SummaryView from "@/routes/apt/[apt_code]/report/_components/summary/summary-view"
import { reportBundle } from "./report-const"

const ReportPage = () => {
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource")
  const startDate = searchParams.get("start_date") ?? ""
  const endDate = searchParams.get("end_date") ?? ""

  const { lang } = langStore()

  useEffect(() => {
    if (!resource || !startDate || !endDate) return

    const toastId = toast.loading(reportBundle.load.loading[lang])

    const action = async () => {
      try {
        const finished = await reportStore.getState().apiGetReport({
          start_date: startDate,
          end_date: endDate,
          resource
        })

        if (!finished) {
          toast.error(reportBundle.load.failed[lang])
        }
      } catch (error) {
        console.error(error)
        toast.error(reportBundle.load.failed[lang])
      } finally {
        toast.dismiss(toastId)
      }
    }

    action()

    return () => {
      toast.dismiss(toastId)
      reportStore.getState().reset()
    }
  }, [resource, startDate, endDate, lang])

  return (
    <div className="w-full h-full">
      <SummaryView />
      <HeatmapView />
    </div>
  )
}

export default ReportPage
